import { createElementBlock as l, openBlock as n, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(d, e) {
  return n(), l("svg", r, e[0] || (e[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "m12.5 8.8 8-6.8v1C19 4.333 16 7.4 16 9s2.5 4.5 4 6c0 0 .2.152.2.4 0 .9-7.7 6.6-7.7 6.6v-1q.219-.194.47-.41c1.547-1.347 3.83-3.332 3.83-5.59 0-1.6-2.967-4.633-4.3-5.8L4 16V2zM9 8.935C9 7.298 5 4 5 4v10s4-3.556 4-5.065",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const s = { render: t };
export {
  s as default,
  t as render
};
//# sourceMappingURL=ic_brand_ds-DtZEACbu.js.map
